module.exports = __webpack_public_path__ + "media/gastritis.adbef417.wav";